// Run before the router and its serializer: older browsers can load modules
// while still lacking this ES2022 API. Syntax transforms do not add built-ins.
if (typeof Object.hasOwn !== "function") {
  Object.defineProperty(Object, "hasOwn", {
    configurable: true,
    writable: true,
    value: function hasOwn(value: object, key: PropertyKey) {
      return Object.prototype.hasOwnProperty.call(value, key);
    },
  });
}
